import { useCallback } from 'react'

export default (callback, disabled) => useCallback((event) => {
  if (disabled) {
    return
  }

  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault()
    callback?.()
  }
}, [callback, disabled])
